import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";

const propTypes = {
  onToggle: PropTypes.func,
  controlled: PropTypes.bool,
};

class Details extends React.Component {
  state = {
    open: !!this.props.open,
    myrtr: this.setMyRtr,
  };

  setMyRtr = () => {
    if (this.props.className.includes("myrtr") && this.state.open === true) {
      return this.props.children;
    }
  };

  isOpen = () => {
    // huh.
    if (this.props.controlled) {
      return this.props.open;
    }

    return this.state.open;
  };

  isMinimizable = () => {
    return _.isUndefined(this.props.isMinimizable) || this.props.isMinimizable;
  };

  onToggle = open => {
    var specificFunctionName = open ? "onOpen" : "onClose";

    this.setState({ open: open });

    if (_.isFunction(this.props[specificFunctionName])) {
      this.props[specificFunctionName]();
    }

    if (_.isFunction(this.props.onToggle)) {
      this.props.onToggle(this, open);
    }
  };

  open = () => {
    this.onToggle(true);
  };

  close = () => {
    this.onToggle(false);
  };

  toggle = () => {
    if (this.isMinimizable()) {
      this.onToggle(!this.isOpen());
    }
  };

  bindSummaryClick = originalOnClick => {
    var ctx = this;

    return function (event) {
      if (_.isFunction(event.preventDefault)) {
        event.preventDefault();
      }

      ctx.toggle();

      if (_.isFunction(originalOnClick)) {
        originalOnClick(this, event);
      }
    };
  };

  componentClassName = () => {
    var previousClass = this.props.className ? this.props.className + " " : "";
    var currentState = this.isOpen() ? " active" : "";

    return previousClass + "collapsible-menu" + currentState;
  };

  render() {
    var ctx = this,
      children,
      props;
    // MyRTR children are formatted differently, index 0 is referring to the all hearts element
    // Conditional if hearts filter is not open then collapse, otherwise render all hearts lists as elements for filter
    if (ctx?.props?.className?.includes("myrtr") && !ctx.isOpen()) {
      return React.cloneElement(this.props.children[0], {
        onClick: ctx.bindSummaryClick(this.props.children[0].props.onClick),
      });
    } else if (ctx?.props?.className?.includes("myrtr") && ctx.isOpen()) {
      ctx.children = this.state.myrtr;
      React.Children.map(this.props.children, function (child) {
        return child;
      });
    }
    children = React.Children.map(this.props.children, function (child, index) {
      var style;

      if (index === 0) {
        // Add our own onClick to the very first child of this component.
        // We expect that that child will be a <summary>, but sometimes it's
        // nested inside another component and we can't get at it directly, so
        // we trust that *that* component will delegate the onClick
        // appropriately.

        return React.cloneElement(child, { onClick: ctx.bindSummaryClick(child.props.onClick) });
      }

      if (!ctx.isOpen()) {
        // Because cross-browser support for <details> is still uneven, we
        // manually hide children of this component after the first one (which
        // we assume to be a <summary>). We could instead choose to skip
        // rendering these elements, but leaving them in the DOM makes this a
        // more realistic polyfill, because a native <details> tag does not
        // change the DOM at all when a user interacts with its <summary>.

        style = child.props.style || {};

        return React.cloneElement(child, { style: _.extend({}, style, { display: "none" }) });
      }

      return child;
    });

    // This component will not know to re-render if we're only change the open
    // attribute, so we include the open-ness in the key to force a refresh.
    // Thanks, React.
    props = _.extend(
      { key: "details-" + (this.isOpen() ? "open" : "closed") },
      _.omit(this.props, "onToggle", "controlled"),
      {
        open: this.isOpen(),
        className: this.componentClassName(),
      }
    );

    return <div {...props}>{children}</div>;
  }
}

Details.propTypes = propTypes;

export default Details;
